import { useQuery as useTanstackQuery } from '@tanstack/react-query';
import type { APIClient } from '../api';
import { buildTypedQueryDescriptor } from './utils';
import type { BuildQueryDescriptorParams } from './utils';

function useBaseQuery<TQueryFnData = unknown, TData = TQueryFnData>(
  url: string,
  client: APIClient,
  params?: BuildQueryDescriptorParams<TQueryFnData, Error, TData>,
) {
  const { queryKey, queryFn, restParams } = buildTypedQueryDescriptor(
    url,
    client,
    params,
  );
  const query = useTanstackQuery<TQueryFnData, Error, TData>({
    queryKey,
    queryFn,
    retry: 1,
    ...restParams,
  });

  return { ...query, queryKey };
}

export default useBaseQuery;
